import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { FaTimes, FaPlus, FaUserAlt } from "react-icons/fa";
import cn from "classnames";
import Popup from "reactjs-popup";

import { Page } from "ui/components";
import { Manifest, Leg } from "services/action";

import epod from "ui/assets/epod.png";
import Input from "ui/components/form/input";

import SignatureSection from "./signature";
import CameraScreen from "./camera";
import ShipmentList from "./list";

const PODScreen = ({ match, location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);
  const session = useSelector((state) => state?.Auth?.session);

  const [data, setData] = React.useState(null);
  const [manifest, setManifest] = React.useState(null);
  const [img, setImage] = React.useState([]);
  const [pos, setPos] = React.useState(null);
  const [receiver, setReceiver] = React.useState("");
  const [note, setNote] = React.useState("");
  const [errorName, setErrorName] = React.useState(false);
  const [errorNote, setErrorNote] = React.useState(false);
  const [completedNote, setCompletedNote] = React.useState("");
  const [sig, setSig] = React.useState(null);
  const [jobs, setJobs] = React.useState([]);

  const [show, setShow] = React.useState(false);

  const $onLoad = async (manifestID, legID) => {
    const req = await Dispatch(Leg.$show(manifestID, legID));

    if (req?.message === "success") {
      $manifestLoad(manifestID);
      setData(req?.data);
    }
  };

  const $manifestLoad = async(manifestID) => {
    const req = await Dispatch(Manifest.$get(manifestID));

    if (req?.message === "success") {
      setManifest(req?.data);
    }
  }

  const $removeImg = async (i) => {
    let newImg = [...img];
    newImg.splice(i, 1);
    setImage(newImg);
  };

  const $onRecord = async (e) => {
    let payload = {
      actor_name: session?.name,
      actor_phone: session?.phone,
      latitude: pos?.lat,
      longitude: pos?.lng,
    };

    if (location?.state?.type === "delivered") {
      if (!receiver) {
        setErrorName(true);
        setTimeout(function () {
          setErrorName(false);
        }, 5000);
        return;
      }

      let imgs = [];
      if (img?.length > 0) {
        const pyl = {
          type: "delivered",
          urls: img,
        };
        imgs?.push(pyl);

        if (sig) {
          const sgt = {
            type: "signature",
            urls: [sig?.image],
          };
          imgs?.push(sgt);
        }
      }

      if (imgs?.length > 0) {
        payload.images = imgs;
      }

      if (jobs?.length > 0 && !data?.is_receive) {
        payload.jobs = jobs;
      }

      payload.received_by = receiver;
      payload.completed_note = completedNote;

      const req = await Dispatch(
        Leg.$delivered(location?.state?.manifest_id, data?.id, payload)
      );

      if (req?.message === "success") {
        History.goBack();
      }
    }

    if (location?.state?.type === "disputed") {
      if (!note) {
        setErrorNote(true);
        setTimeout(function () {
          setErrorNote(false);
        }, 5000);
        return;
      }

      payload.images = img;
      payload.disputed_note = note;

      const req = await Dispatch(
        Leg.$dispute(location?.state?.manifest_id, data?.id, payload)
      );

      if (req?.message === "success") {
        History.goBack();
      }
    }
  };

  React.useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setPos({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (error) => {
        // See error code charts below.
        console.log(error.code, error.message);
      },
      { enableHighAccuracy: true, timeout: 60000, maximumAge: Infinity }
    );
  }, []);

  React.useEffect(() => {
    if (match?.params?.id && location?.state?.manifest_id) {
      $onLoad(location?.state?.manifest_id, match?.params?.id);
    }
  }, [match, location]);

  React.useEffect(() => {
    if (!img || img?.length === 0) {
      setShow(true);
    }
  }, [img]);

  return (
    <Page
      title={<img src={epod} alt="" height={25} />}
      backTo={() => History.goBack()}
      full
      action={
        <div>
          <Button
            type="button"
            variant="success"
            className={cn(
              "pe-4 ps-4 rounded w-100 fs-7",
              StateForm?.loading ? "btn-loading" : ""
            )}
            onClick={$onRecord}
            disabled={StateForm?.loading}
          >
            Simpan
          </Button>
        </div>
      }
    >
      <div className="px-2 py-3">
        <div className="row align-items-center justify-content-center ">
          {img?.map((d, i) => (
            <div
              key={i}
              className="position-relative col-4"
              style={{ height: 100, width: 100, margin: 5 }}
            >
              <div
                className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center bg-danger rounded-circle border border-2 border-white mt-n2 me-n1 rounded"
                style={{ height: 25, width: 25 }}
                onClick={() => $removeImg(i)}
              >
                <FaTimes color="#fff" />
              </div>
              <img
                src={d}
                alt=""
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: 5,
                }}
              />
            </div>
          ))}

          {StateForm?.loading ? (
            <div
              className="col-4 rounded bg-dark bg-opacity-25 d-flex flex-column align-items-center justify-content-center"
              style={{ height: 100, width: 80, margin: 5 }}
            >
              <div className="spinner-border text-blue" role="status"></div>
              <div>
                <small>uploading</small>
              </div>
            </div>
          ) : null}

          <div
            className="col-4 d-flex flex-column align-items-center justify-content-center"
            onClick={() => setShow(true)}
          >
            <div
              className={cn(
                "border-dashed rounded  d-flex flex-column align-items-center justify-content-center",
                StateForm?.errors?.images ? "border-danger" : "border-primary"
              )}
              style={{ height: 100, width: 80, margin: 5 }}
            >
              <FaPlus
                size={20}
                color={StateForm?.errors?.images ? "red" : "#2f83ba"}
              />
              <div>
                <small>ambil foto</small>
              </div>
            </div>

            {StateForm?.errors?.images ? (
              <div
                className="text-center"
                style={{ marginBottom: 5, marginTop: 10 }}
              >
                <span style={{ color: "red" }}>
                  {StateForm?.errors?.images}
                </span>
              </div>
            ) : null}
          </div>
        </div>

        {StateForm?.errors?.id ? (
          <div
            className="text-center"
            style={{ marginBottom: 5, marginTop: 10 }}
          >
            <span style={{ color: "red" }}>{StateForm?.errors?.id}</span>
          </div>
        ) : null}
      </div>

      {location?.state?.type === "delivered" ? (
        <div className="px-2 py-3">
          <div className="mb-3">
            <div>Diterima Oleh:</div>
            <div className="form-group mb-3 ">
              <Input
                icon={<FaUserAlt />}
                value={receiver}
                onChange={(e) => setReceiver(e.target.value)}
                type="text"
                placeholder="masukkan nama penerima"
                error={errorName}
                lg
              />
              {errorName ? (
                <div
                  className="invalid-feedback mt-n1"
                  style={{ display: "block" }}
                >
                  Nama Penerima harus diisi
                </div>
              ) : null}
            </div>

            <div>Keterangan:</div>
            <div className="form-group mb-3 ">
              <Input
                value={completedNote}
                onChange={(e) => setCompletedNote(e.target.value)}
                type="text"
                placeholder="masukkan keterangan"
                lg
              />
            </div>
          </div>

          {sig ? (
            <div
              className="position-relative border border-primary rounded bg-white"
              style={{ height: 150, margin: 5 }}
            >
              <div
                className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center bg-danger rounded-circle border border-2 border-white mt-n2 me-n1 rounded"
                style={{ height: 25, width: 25 }}
                onClick={() => setSig(null)}
              >
                <FaTimes color="#fff" />
              </div>
              <img
                src={sig?.image}
                alt=""
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                  borderRadius: 5,
                }}
              />
            </div>
          ) : (
            <Popup
              modal
              trigger={
                <button className="btn btn-primary fs-7 w-100">
                  Ambil Tanda Tangan
                </button>
              }
              closeOnDocumentClick={false}
            >
              {(close) => (
                <SignatureSection
                  setSig={setSig}
                  onClose={close}
                  loading={StateForm?.loading}
                />
              )}
            </Popup>
          )}
        </div>
      ) : null}

      {location?.state?.type === "disputed" && (
        <div className="px-2 py-3">
          <div>Alasan:</div>
          <div className="form-group mb-3 ">
            <Input
              value={note}
              onChange={(e) => setNote(e.target.value)}
              type="text"
              placeholder="masukkan alasan"
              error={errorNote || StateForm?.errors?.disputed_note}
              lg
            />
            {errorNote ? (
              <div
                className="invalid-feedback mt-n1"
                style={{ display: "block" }}
              >
                Catatan harus diisi
              </div>
            ) : null}
          </div>
        </div>
      )}

      {(location?.state?.type === 'loading' ||
      (!data?.is_receive && location?.state?.manifest_type === "last_mile" && location?.state?.type === "delivered")) && (
        <div className="px-2 py-3">
          <ShipmentList
            data={data}
            manifest={manifest}
            type="delivered"
            onChange={(e) => setJobs(e)}
          />
        </div>
      )}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
        fullscreen
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <CameraScreen
            setImg={setImage}
            numberImg={img?.length}
            onClose={() => setShow(false)}
            code={location?.state?.manifest_id}
            type={location?.state?.type}
          />
        </Modal.Body>
      </Modal>
    </Page>
  );
};

export default PODScreen;
